import {minBy} from "lodash";

const defaultOptions = {

  open: true,

  sortItems: [
    {'key': 'order', 'direction': 'asc'}
  ],

  chartXAxesBreakpoints: [
    {'default': 200},
    {'0': 5},
    {'50': 10},
    {'150': 20},
    {'300': 50},
    {'700': 100},
  ],

  get defaultXBreakpoint() {
    return this.chartXAxesBreakpoints[0].default
  },

  calculateXStepSizeByMaxValue(maxValue) {
    const eligibleOptions = this.chartXAxesBreakpoints
      .map(option => {
        const key = Object.keys(option)[0]
        return {'name': key, 'value': option[key]}
      }).filter(option => {
          return option.name !== 'default' && parseInt(option.name) >= maxValue
        }
      )

    if (!eligibleOptions)
      return Object.values(this.chartXAxesBreakpoints[this.chartXAxesBreakpoints.length - 1])[0]

    return minBy(eligibleOptions, 'name')?.value ?? this.defaultXBreakpoint
  }

}

export default defaultOptions
